import React, { useState, useRef } from 'react';
import {
    List, Datagrid, TextField, useRefresh, SimpleForm, Button as RaButton, SimpleList
} from 'react-admin';
import {
    useMediaQuery, Box, CircularProgress, makeStyles, Button, Dialog, DialogActions, DialogTitle, Portal, DialogContent,
    TextField as MuiTextField, IconButton, Typography, FormControl, InputLabel, Select, MenuItem, List as MuiList, ListItem, ListItemIcon, ListItemText, Checkbox, ListItemSecondaryAction
} from '@material-ui/core';
import { customTheme } from "./customTheme";
// import CustomSearch from './components/CustomSearch';
// import CustomFilter from './components/CustomFilter';
import config from "./config.json";
import queryString from 'query-string';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import RaAutocompleteInput from './components/RaAutocompleteInput';
import PaymentIcon from '@material-ui/icons/Payment';
import CustomSearch from './components/CustomSearch';
import { Helmet } from "react-helmet";
import CustomExportButton from './components/CustomExportButton';
import DisplayColumnsButton from './components/DisplayColumnsButton';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import { useLocation } from 'react-router-dom';
import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";
import DateTimePickerToolbar from "./components/DateTimePickerToolbar";
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import DateRangeIcon from '@material-ui/icons/DateRange';
import CustomPagination from './components/CustomPagination';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import notify from './components/CustomUseNotify';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 350
    },
    dialogButton: {
        borderRadius: 100,
        padding: "8px 25px"
    },
    dialogPaperBig: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 500
    },
    input: {
        width: "500px"
    },
    MuiInputBase: {
        root: {
            width: "800px"
        }
    },
    timeFilterInput: {
        marginLeft: "2%",
    },
    searchParamsTitle: {
        fontSize: "1.05rem",
        color: "#7076839e"
    },
    searchParams: {
        fontFamily: "Poppins-Regular",
        fontSize: "0.95rem",
        color: "#7076839e"
    },
    listItemText: {
        fontSize: '12px',
    }
});

const CATEGORY = "DEVICE WALLET SECTION"
// const searchTypes = ["Serial Number", "Device Name"];
const DEVICE_WALLET_COLUMNS = {
    "Device Name": true,
    "Serial Number": true,
    "Parking Name": true,
    "Balance": true,
    "Recharge": true,
    "Payment Card": true
};
export const DeviceWalletList = (props) => {
    const eventTracker = UseAnalyticsEvent()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const classes = useStyles();
    const location = useLocation();
    const listDataRef = useRef();

    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});

    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    let searchTypeState = ["Serial Number", "Device Name", "Card Number"]
    const [search, setSearch] = useState(prevSearch.inputSearch)
    const [searchType, setSearchType] = useState(prevSearch.type ? prevSearch.type : "Serial Number");
    const [displayColumns, setDisplayColumns] = useState(DEVICE_WALLET_COLUMNS);
    // const [filterListValue, setFilterListValue] = useState(null)
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");

    const filter = { search: { value: search, type: searchType }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const getExportFile = (fileType) => {
        const {current : {total, currentSort, filterValues}} = listDataRef
        const params = {
            filter: JSON.stringify({ ...filter, ...filterValues }),
            sort: JSON.stringify([currentSort.field, currentSort.order]),
            page: 1,
            perPage: total,
            user_id: sessionStorage.getItem("user_id")
        };
        fetch(`${config.HOST_NAME}/crm/v3/deviceWallet?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Accept': `application/${fileType}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                tempLinkElement.setAttribute('download', `${currentParking && currentParking.name ? currentParking.name : "Device Wallets"}.${fileType}`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    const getExcelFile = () => {
        getExportFile("xlsx");
    };

    React.useEffect(() => {
        eventTracker(CATEGORY, " WALLETS LIST")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div>
            <Helmet>
                <script src="https://checkout.razorpay.com/v1/checkout.js"></script>
            </Helmet>

            <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
                {showFilter && <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                />}

                {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                    <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                        <InputLabel>Zone Name</InputLabel>
                        <Select
                            value={currentParking.allZones ? "All" : currentParking.id}
                            onChange={onZoneChange}
                            label="Zone Name"
                            variant="outlined"
                        >
                            <MenuItem value="All">All</MenuItem>
                            {finalZones.map((zone, index) => (
                                <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </div>
            <div className='customStyleForDataSearchDiv'>
                <CustomSearch search={search} setSearch={setSearch} searchTypes={searchType} setSearchTypes={setSearchType} searchTypeState={searchTypeState} pathName={location.pathname} />
                {!viewOnly && <MultipleRechargeButton currentParking={currentParking} />}
                <DisplayColumnsButton defaultColumns={DEVICE_WALLET_COLUMNS} displayColumns={displayColumns} setDisplayColumns={setDisplayColumns} />
                <CustomExportButton getCSV={getExcelFile} disabled={listDataRef.current && listDataRef.current.total === 0} />
            </div>
            <List
                {...props}
                style={{marginTop: 20}}
                empty={false}
                title="Device Wallet"
                bulkActionButtons={false}
                exporter={false}
                sort={{ field: 'unique_user_id', order: 'DESC' }}
                filter={filter}
                actions={false}
                pagination={<CustomPagination setListData={(listData) => {listDataRef.current = listData}} />}
            >
                {isSmallDevice ?
                    <SimpleList
                        primaryText={record => record["serial_number"]}
                        secondaryText={record => (<div>
                            {record.unique_user_id && <div><span style={{ color: "#5a5a5a" }}>Device Name: </span>{record.unique_user_id}</div>}
                            {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking Name: </span>{record.parking_name}</div>}
                            {!viewOnly && <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <WalletAmountDialog source="balance" record={record} label="Wallet Amount" />
                                <RechargeButton label="Recharge" record={record} />
                                <AssignCard label="Payment Card" record={record} />
                            </div>}
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid component={ScrollableTable}>
                        {displayColumns["Serial Number"] && <TextField source="serial_number" label="Serial Number" />}
                        {displayColumns["Device Name"] && <TextField source="unique_user_id" label="Device Name" />}
                        {displayColumns["Parking Name"] && <TextField source="parking_name" label="Parking Name" />}
                        {!viewOnly && <WalletAmountDialog source="balance" label="Wallet Amount" />}
                        {!viewOnly && displayColumns["Recharge"] && <RechargeButton label="Recharge" />}
                        {!viewOnly && displayColumns["Payment Card"] && <AssignCard label="Payment Card" />}
                    </Datagrid>
                }
            </List>
        </div>
    )
};

function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

function RechargeButton(props) {
    const { record } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));
    //const notify = useNotify();
    const refresh = useRefresh();
    const classes = useStyles();

    const [loading, setLoading] = useState(false);
    const [paymentFailedDialog, setPaymentFailedDialog] = useState(null);
    const [paymentMethodDialogVisible, setPaymentMethodDialogVisible] = useState(false);
    const [amount, setAmount] = useState("100");
    const [paymentMethod] = useState("Digital");

    const handleAmountChange = event => {
        if (!isNaN(event.target.value)) {
            setAmount(event.target.value);
        }
    };

    const handleAmountBlur = event => {
        if (event.target.value === "") {
            setAmount("0");
        }
    };

    const updateWalletPaymentStatus = async (transactionId, paymentStatus, remarks) => {
        fetch(`${config.HOST_NAME}/crm/walletTransactions/${transactionId}/status`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ payment_status: paymentStatus, remarks: remarks, serial_number: record.serial_number, access_key_id: record.access_key_id })
        });
    };

    const closePaymentFailedDialog = () => {
        setPaymentFailedDialog(null);
    };

    const rechargeWallet = async (event) => {
        event.preventDefault();
        if (amount === "" || isNaN(amount) || !(amount >= 0)) {
            return notify("Invalid Amount", "warning");
        }
        if (paymentMethod == null) {
            return notify("Please select a payment method", "warning");
        }

        if (paymentMethod === "Cash") {
            rechargeWalletCash(event);
        } else {
            rechargeWalletDigital(event);
        }
    };

    const rechargeWalletDigital = async (event) => {
        event.preventDefault();
        closePaymentFailedDialog();
        closePaymentModeDialog();

        setLoading(true);
        fetch(`${config.HOST_NAME}/crm/initiateDeviceWalletRecharge`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ serial_number: record.serial_number, access_key_id: record.access_key_id, amount: parseFloat(amount) })
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    const order = json.data.order;
                    var options = {
                        description: 'Wallet Recharge',
                        currency: order.currency,
                        key: config.RAZOR_PAY_KEY_ID,
                        amount: order.amount,
                        name: 'ParkSmart',
                        order_id: order.id,
                        notes: {
                            serial_number: record.serial_number,
                            access_key_id: record.access_key_id,
                            parking_name: record.parking_name,
                        },
                        theme: {
                            color: customTheme.palette.primary.main
                        },
                        modal: {
                            ondismiss: () => {
                                setLoading(false);
                                const description = "Payment is cancelled by user";
                                setPaymentFailedDialog(description);
                                updateWalletPaymentStatus(json.data.transaction_id, "CANCELLED", description);
                            }
                        },
                        handler: checkoutData => {
                            fetch(`${config.HOST_NAME}/crm/verifyDeviceWalletRecharge`, {
                                method: 'POST',
                                headers: {
                                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({ ...checkoutData, transaction_id: json.data.transaction_id, serial_number: record.serial_number, access_key_id: record.access_key_id }),
                            })
                                .then(response => {
                                    saveTokens(response)
                                    return response.json()
                                })
                                .then(json => {
                                    setLoading(false);
                                    if (json.success) {
                                        notify("Payment Successful", "success");
                                        refresh();
                                    } else {
                                        setPaymentFailedDialog(json.message);
                                    }
                                })
                                .catch((error) => {
                                    setLoading(false);
                                    setPaymentFailedDialog("Could not verify Payment");
                                });
                        },
                    }
                    const razorpay = new window.Razorpay(options);
                    razorpay.on('payment.failed', function ({ error }) {
                        setLoading(false);
                        let description, status;
                        if (isJsonString(error.description)) {
                            const errorObj = JSON.parse(error.description);
                            if (errorObj.error) {
                                description = errorObj.error.description;
                                status = errorObj.error.reason;
                            } else {
                                description = errorObj.description;
                                status = errorObj.reason;
                            }
                        } else {
                            description = error.description;
                        }
                        setPaymentFailedDialog(description);
                        updateWalletPaymentStatus(json.data.transaction_id, status === "payment_cancelled" ? "CANCELLED" : "FAILED", description);
                    });

                    razorpay.open();
                } else {
                    setLoading(false);
                    notify(json.message, "warning");
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
                notify("Check your internet connection", "warning");
            });
    };

    const rechargeWalletCash = (event) => {
        event.preventDefault();
        closePaymentModeDialog();

        setLoading(true);
        const rfidId = record["id"];
        fetch(`${config.HOST_NAME}/crm/rfidData/${rfidId}/recharge`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ amount: amount })
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false);
                if (json.success) {
                    notify(json.message, "success");
                    refresh();
                } else {
                    notify(json.message, "warning");
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
                notify("Check your internet connection", "warning");
            });
    };

    const openPaymentModeDialog = () => {
        setPaymentMethodDialogVisible(true);
    };

    const closePaymentModeDialog = () => {
        setPaymentMethodDialogVisible(false);
    };
    if (!record) return null

    return (
        <div style={{ display: isSmallDevice ? "flex" : "block", alignItems: "center", flex: 1 }}>
            <RaButton label="Recharge" color="secondary" onClick={openPaymentModeDialog}><PaymentIcon /></RaButton>

            <Portal>
                <Dialog open={paymentMethodDialogVisible} onClose={closePaymentModeDialog} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle style={{ color: customTheme.palette.secondary.main }}><div style={{ fontSize: 16, textAlign: "center" }}>Recharge</div></DialogTitle>
                    <DialogContent style={{ fontSize: 14, marginTop: 0, marginBottom: 0 }}>
                        <MuiTextField value={amount} onChange={handleAmountChange} onBlur={handleAmountBlur} label="Amount" variant="outlined" size="small" />
                        {/* <RadioGroup row value={paymentMethod} onChange={event => setPaymentMethod(event.target.value)} style={{ columnGap: 15, marginTop: 10 }}>
                            <FormControlLabel className="formLabel-regular" value="Digital" control={<Radio color="primary" />} label="Digital" />
                            <FormControlLabel className="formLabel-regular" value="Cash" control={<Radio color="primary" />} label="Cash" />
                        </RadioGroup> */}
                    </DialogContent>

                    <DialogActions style={{ display: "flex", justifyContent: "space-evenly" }}>
                        <Button className={classes.dialogButton} variant="outlined" color="default" onClick={closePaymentModeDialog}>Cancel</Button>
                        <Button disableElevation className={classes.dialogButton} variant="contained" color="secondary" onClick={rechargeWallet}>Recharge</Button>
                    </DialogActions>
                </Dialog>
            </Portal>

            {loading && <Portal>
                <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "#0001", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <CircularProgress size={50} />
                </div>
            </Portal>}

            <Portal>
                <Dialog open={!!paymentFailedDialog} onClose={closePaymentFailedDialog} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle style={{ color: customTheme.palette.error.main }}><div style={{ fontSize: 16, textAlign: "center" }}>Payment Failed!</div></DialogTitle>
                    <DialogContent style={{ fontSize: 14, marginTop: 0, marginBottom: 10 }}>Description: {paymentFailedDialog}</DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "space-evenly" }}>
                        <Button className={classes.dialogButton} variant="outlined" color="default" onClick={closePaymentFailedDialog}>Cancel</Button>
                        <Button disableElevation className={classes.dialogButton} variant="contained" color="secondary" onClick={rechargeWalletDigital}>Retry</Button>
                    </DialogActions>
                </Dialog>
            </Portal>
        </div>
    );
}

const AssignCard = (props) => {
    const classes = useStyles();
    const { record } = props
    //const notify = useNotify();
    const refresh = useRefresh();

    const [selectedOptions, setSelectedOptions] = useState("");

    const surfaceId = useRef("");
    const [open, setOpen] = React.useState(false);
    const [assignLoader, setAssignLoader] = useState(false);
    const [removeLoader, setRemoveLoader] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const assignHandler = () => {
        setAssignLoader(true);
        fetch(`${config.HOST_NAME}/crm/v3/assignOperatorWalletCard`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ serial_number: record.serial_number, access_key_id: record.access_key_id, surface_id: surfaceId.current, nfc_uid: selectedOptions }),
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    notify("Successfully Assigned", "success");
                    setOpen(false);
                    setAssignLoader(false);
                    setSelectedOptions("");
                    refresh();
                } else {
                    notify(json.message, "warning");
                    setAssignLoader(false);
                }
            })
            .catch((error) => {
                console.log(error);
                notify("Something went wrong", "warning");
                setAssignLoader(false);
            });

    };

    const removeHandler = () => {
        setRemoveLoader(true)
        fetch(`${config.HOST_NAME}/crm/v3/removeOperatorWalletCard`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ serial_number: record.serial_number, access_key_id: record.access_key_id }),
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    notify("Successfully Removed", "success");
                    setOpen(false);
                    setRemoveLoader(false);
                    refresh();
                } else {
                    notify(json.message, "warning");
                    setAssignLoader(false);
                }
            })
            .catch((error) => {
                console.log(error);
                notify("Something went wrong", "warning");
                setRemoveLoader(false);
            });
    };

    if (!record) return null
    return (
        <div>
            <div>
                {record.nfc_uid == null && <Button variant="contained" color="primary" style={{ borderRadius: 100 }} onClick={handleClickOpen} disableElevation>Assign Card</Button>}
                {record.nfc_uid !== null && <div variant="contained" style={{ color: customTheme.palette.error.main, display: "flex", justifyContent: "start", alignItems: "start", flexDirection: "column", lineHeight: "0px", marginLeft: "15px", fontWeight: "bold" }}>
                    <p style={{ color: "#BDBDBD" }}>{record.surface_id}</p>
                    <p onClick={handleClickOpen} style={{ cursor: "pointer" }}>Remove Card</p>
                </div>}

                <Dialog
                    open={open}
                    onClose={handleClose}
                    fullWidth
                    classes={{ paper: classes.dialogPaper }}
                >
                    <div style={{ width: "100%" }}>
                        {record.nfc_uid == null && <SimpleForm style={{ padding: '0 22px' }} toolbar={false}>
                            <div style={{ width: "100%" }}>
                                <p style={{ fontSize: 15, fontWeight: "500", color: "black" }}>Select Card</p>
                                <RaAutocompleteInput
                                    source="search"
                                    resourceParam="search"
                                    filter={{ available: true }}
                                    customSort={["surface_id", "ASC"]}
                                    resourcePath="cardsInventory"
                                    label=""
                                    getOptionValue={(option) => {
                                        //setSurfaceId(option['surface_id'])
                                        surfaceId.current = option['surface_id']
                                        return option['nfc_uid']
                                    }}
                                    getOptionLabel={(option) =>
                                        `${option['surface_id']} - ${option['nfc_uid']}`
                                    }
                                    onSelect={(value) => setSelectedOptions(value)}
                                />
                            </div>
                        </SimpleForm>}

                        {record.nfc_uid !== null && <SimpleForm toolbar={false}>
                            <div style={{ paddingTop: "10px" }}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <Box>
                                        <p style={{ fontSize: 15, fontWeight: "500", color: "black" }}>Are you sure you want to <strong>Remove</strong> this card.</p>
                                    </Box>
                                </div>
                            </div>
                        </SimpleForm>}
                    </div>

                    {record.nfc_uid == null && <DialogActions style={{ padding: "22px 35px" }}>
                        <Button onClick={handleClose} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                            Cancel
                        </Button>
                        <Button onClick={assignHandler} color="primary" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} disableElevation>
                            Assign {assignLoader && <CircularProgress color="secondary" size={25} style={{ marginLeft: "10px" }} />}
                        </Button>
                    </DialogActions>}

                    {record.nfc_uid !== null && <DialogActions style={{ padding: "22px 35px" }}>
                        <Button onClick={handleClose} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                            Cancel
                        </Button>
                        <Button onClick={removeHandler} color="contained" variant='contained' style={{ backgroundColor: customTheme.palette.error.main, color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} autoFocus disableElevation>
                            Remove {removeLoader && <CircularProgress color="secondary" size={25} style={{ marginLeft: "10px" }} />}
                        </Button>
                    </DialogActions>}
                </Dialog>
            </div>
        </div>
    );
}

const WalletAmountDialog = ({ record }) => {
    const classes = useStyles();
    //const notify = useNotify();
    const [open, setOpen] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [startDateTime, setStartDateTime] = React.useState(Date.now());
    const [walletAmount, setWalletAmount] = React.useState("")

    const handleClose = () => {
        setOpen(false)
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const walletAmountHandler = () => {
        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/v3/getWalletAmount?start_time=${moment(startDateTime).format("YYYY-MM-DD HH:mm:ss")}&wallet_id=${record.operator_devices_wallet_id}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            }
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    console.log(json.data)
                    setWalletAmount(json.data)
                    // notify("Successfully Logout", "success");
                    // setOpen(false)
                    setLoading(false)
                    // refresh()
                } else {
                    notify(json.message, "warning");
                    setLoading(false)
                }
            })
            .catch((error) => {
                console.log(error)
                notify("Something went wrong", "warning");
                setLoading(false)
            });
    }

    React.useEffect(() => {
        walletAmountHandler()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div>

            <p style={{ display: "inline" }}>₹ {record && record.balance ? record.balance : 0}</p>
            <IconButton style={{ color: "#18cc69" }} onClick={handleClickOpen}> <DateRangeIcon style={{ fontSize: "20px" }} /></IconButton>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                classes={{ paper: classes.dialogPaperBig }}
                BackdropProps={{
                    classes: {
                        root: classes.backDrop
                    }
                }}
            >
                <DialogContent>
                    <div style={{ display: "grid", gridTemplateColumns: "60% 40%", justifyContent: "space-around", alignItems: "center", gap: 20 }}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DateTimePicker
                                disableFuture
                                ampm
                                value={startDateTime}
                                onChange={(datetime) => setStartDateTime(datetime)}
                                label="Balance Until"
                                className={classes.timeFilterInput}
                                inputVariant="outlined"
                                TextFieldComponent={(props) => <MuiTextField {...props} size="small" />}
                                ToolbarComponent={DateTimePickerToolbar}
                                format="dd/MM/yyyy hh:mm a"
                            />
                        </MuiPickersUtilsProvider>
                        <Button onClick={walletAmountHandler} color="contained" variant='contained' style={{ backgroundColor: '#18cc69', color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} autoFocus disableElevation>
                            Calculate   {loading && <CircularProgress size="1rem" sx={{ color: "white", marginLeft: "20px" }} thickness={6}></CircularProgress>}
                        </Button>
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: "60% 40%", justifyContent: "space-around", alignItems: "center", marginTop: 30 }}>
                        <Typography style={{ fontSize: 20, fontWeight: "bold" }}>Total Amount</Typography><Typography style={{ fontSize: 30, color: "#18cc69", textAlign: "right", fontWeight: "bold" }}>₹ {walletAmount ? walletAmount : 0}</Typography>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

function MultipleRechargeButton(props) {
    const { currentParking } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));
    //const notify = useNotify();
    const refresh = useRefresh();
    const classes = useStyles();

    const [loading, setLoading] = useState(false);
    const [paymentFailedDialog, setPaymentFailedDialog] = useState(null);
    const [rechargeEditDialogVisible, setRechargeEditDialogVisible] = useState(false);
    const [amountLessThan, setAmountLessThan] = useState("1200");
    const [bulkRechargeWalletIds, setBulkRechargeWalletIds] = useState([])
    const [loadWalletsAmount, setLoadWalletsAmount] = useState(false)
    const [step, setStep] = useState(0)
    const [selectedRechargeIds, setSelectedRechargeIds] = React.useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false)

    const handleToggle = (value) => () => {
        const currentIndex = selectedRechargeIds.indexOf(value);
        const newChecked = [...selectedRechargeIds];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setSelectedRechargeIds(newChecked);
    };

    let totalSelectedRechargeIdAmount = selectedRechargeIds.reduce((n, { amount_to_recharge }) => n + amount_to_recharge, 0)

    const handleChange = (event) => {
        const value = event.target.checked;
        setIsAllSelected(event.target.checked);
        if (value) {
            setSelectedRechargeIds([...bulkRechargeWalletIds]);
            return
        } else {
            setSelectedRechargeIds([]);
        }
    };

    const handleAmountLessThanChange = event => {
        if (!isNaN(event.target.value)) {
            setAmountLessThan(event.target.value);
        }
    };

    const handleAmountLessThanBlur = event => {
        if (event.target.value === "") {
            setAmountLessThan("0");
        }
    };

    // const amountPerDevice = amount !== "" && !isNaN(amount) ? Math.round(parseFloat(amount) * 100) / 100 : 0;

    const updateWalletPaymentStatus = async (transactionId, paymentStatus, remarks) => {
        fetch(`${config.HOST_NAME}/crm/walletTransactions/${transactionId}/statusBulk`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify({ payment_status: paymentStatus, remarks: remarks })
        });
    };

    const closePaymentFailedDialog = () => {
        setPaymentFailedDialog(null);
    };

    const rechargeWalletDigital = async (event) => {
        event.preventDefault();
        if (totalSelectedRechargeIdAmount === "" || isNaN(totalSelectedRechargeIdAmount) || !(totalSelectedRechargeIdAmount >= 0)) {
            return notify("Invalid Amount", "warning");
        }

        closePaymentFailedDialog();
        closeRechargeEditDialog();

        setLoading(true);
        fetch(`${config.HOST_NAME}/crm/initiateDeviceWalletRechargeBulk`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify({ bulk_recharge_ids: selectedRechargeIds, bulk_amount: totalSelectedRechargeIdAmount })
        })
            .then(response => response.json())
            .then(json => {
                if (json.success) {
                    const order = json.data.order;
                    var options = {
                        description: 'Wallet Recharge',
                        currency: order.currency,
                        key: config.RAZOR_PAY_KEY_ID,
                        amount: order.amount,
                        name: 'ParkSmart',
                        order_id: order.id,
                        notes: {
                            serial_number: selectedRechargeIds[0].serial_number,
                            parking_name: "Jammu"
                        },
                        theme: {
                            color: customTheme.palette.primary.main
                        },
                        modal: {
                            ondismiss: () => {
                                setLoading(false);
                                const description = "Payment is cancelled by user";
                                setPaymentFailedDialog(description);
                                updateWalletPaymentStatus(json.data.transaction_id, "CANCELLED", description);
                            }
                        },
                        handler: checkoutData => {
                            fetch(`${config.HOST_NAME}/crm/verifyDeviceWalletRechargeBulk`, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                                },
                                body: JSON.stringify({ ...checkoutData, transaction_id: json.data.transaction_id, bulk_recharge_ids: selectedRechargeIds, bulk_amount: totalSelectedRechargeIdAmount }),
                            })
                                .then(response => response.json())
                                .then(json => {
                                    setLoading(false);
                                    if (json.success) {
                                        notify("Payment Successful", "success");
                                        refresh();
                                    } else {
                                        setPaymentFailedDialog(json.message);
                                    }
                                })
                                .catch((error) => {
                                    setLoading(false);
                                    setPaymentFailedDialog("Could not verify Payment");
                                });
                        },
                    }
                    const razorpay = new window.Razorpay(options);
                    razorpay.on('payment.failed', function ({ error }) {
                        setLoading(false);
                        let description, status;
                        if (isJsonString(error.description)) {
                            const errorObj = JSON.parse(error.description);
                            if (errorObj.error) {
                                description = errorObj.error.description;
                                status = errorObj.error.reason;
                            } else {
                                description = errorObj.description;
                                status = errorObj.reason;
                            }
                        } else {
                            description = error.description;
                        }
                        setPaymentFailedDialog(description);
                        updateWalletPaymentStatus(json.data.transaction_id, status === "payment_cancelled" ? "CANCELLED" : "FAILED", description);
                    });

                    razorpay.open();
                } else {
                    setLoading(false);
                    notify(json.message, "warning");
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
                notify("Check your internet connection", "warning");
            });
    };

    const openRechargeEditDialog = () => {
        setRechargeEditDialogVisible(true);
    };

    const closeRechargeEditDialog = () => {
        setRechargeEditDialogVisible(false);
        setStep(0)
    };

    const deviceWalletsUnderAmount = () => {
        let params = {
            filter: JSON.stringify({ amount_less_than: amountLessThan, access_key: currentParking.id }),
            user_id: sessionStorage.getItem('user_id')
        }
        setLoadWalletsAmount(true)
        fetch(`${config.HOST_NAME}/crm/v3/getDeviceWalletsBalance?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        })
            .then(response => response.json())
            .then(json => {
                if (json.success) {
                    if (json.data.bulk_recharge_ids.length === 0) {
                        notify(`Didn't Find Any Wallet Balance Under ${amountLessThan}`, "info");
                        setLoadWalletsAmount(false)
                    } else {
                        setBulkRechargeWalletIds(json.data.bulk_recharge_ids)
                        setLoadWalletsAmount(false)
                        setStep(1)
                        setIsAllSelected(false);
                        setSelectedRechargeIds([]);
                    }
                } else {
                    notify(json.message, "warning");
                    setLoadWalletsAmount(false)
                }
            })
            .catch((error) => {
                console.log(error)
                notify("Something went wrong", "warning");
                setLoadWalletsAmount(false)
            });
    }

    return (
        <div style={{ display: isSmallDevice ? "flex" : "block", alignItems: "center"}}>
            <RaButton className='customCreateBtnStyle' title="Recharge All" onClick={openRechargeEditDialog}><PaymentIcon style={{fontSize: 22}} /></RaButton>

            <Portal>
                <Dialog open={rechargeEditDialogVisible} onClose={closeRechargeEditDialog} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle style={{ color: customTheme.palette.secondary.main }}><div style={{ fontSize: 16, textAlign: "center" }}>Recharge All</div></DialogTitle>
                    <DialogContent style={{ fontSize: 14, marginTop: 0, marginBottom: 0 }}>
                        <MuiTextField style={{ width: 250 }} value={amountLessThan} onChange={handleAmountLessThanChange} onBlur={handleAmountLessThanBlur} label="Minimum balance to maintain" variant="outlined" size="small" disabled={step === 1} />
                        {
                            step === 1 &&
                            <>
                                <div style={{ display: "flex", alignItems: "center", columnGap: 6, minWidth: 200, marginTop: 4 }}>
                                    <InfoOutlinedIcon style={{ fontSize: 20, color: "#aaa" }} />
                                    <div style={{ fontSize: 14, color: "#999" }}>Balance of {bulkRechargeWalletIds.length} devices is under ₹{amountLessThan}</div>
                                </div>

                                <MuiList style={{ maxHeight: 280, overflow: 'auto', marginTop: 10, marginBottom: 10 }}>
                                    <ListItem role={undefined} dense button>
                                        <ListItemIcon>
                                            <Checkbox
                                                edge="start"
                                                onChange={handleChange} checked={isAllSelected}
                                                tabIndex={-1}
                                                disableRipple
                                            />
                                        </ListItemIcon>
                                        <ListItemText primary={"Select All"} />
                                    </ListItem>
                                    {bulkRechargeWalletIds.map((value) => {
                                        const labelId = `checkbox-list-label-${value.serial_number}`;
                                        return (
                                            <ListItem key={value.serial_number} role={undefined} dense button onClick={handleToggle(value)}>
                                                <ListItemIcon>
                                                    <Checkbox
                                                        edge="start"
                                                        checked={selectedRechargeIds.indexOf(value) !== -1}
                                                        tabIndex={-1}
                                                        disableRipple
                                                        inputProps={{ 'aria-labelledby': labelId }}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText classes={{ primary: classes.listItemText, secondary: classes.listItemText }} id={labelId} primary={value.device_name ? value.device_name : value.serial_number} secondary={value.device_name ? value.serial_number : null} />
                                                <ListItemSecondaryAction style={{ color: "#18cc69", fontSize: 12 }}>
                                                    +₹{value.amount_to_recharge}
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        );
                                    })}
                                </MuiList>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", columnGap: 20, marginTop: 0 }}>
                                    <div style={{}}>No. of devices</div>
                                    <div style={{}}>{selectedRechargeIds.length}</div>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", columnGap: 20, marginTop: 0 }}>
                                    <div style={{ fontWeight: "bold" }}>Total Amount</div>
                                    <div style={{ fontWeight: "bold", color: customTheme.palette.secondary.main }}>₹{totalSelectedRechargeIdAmount}</div>
                                </div>
                            </>
                        }

                        {/* <RadioGroup row value={paymentMethod} onChange={event => setPaymentMethod(event.target.value)} style={{ columnGap: 15, marginTop: 10 }}>
                            <FormControlLabel className="formLabel-regular" value="Digital" control={<Radio color="primary" />} label="Digital" />
                            <FormControlLabel className="formLabel-regular" value="Cash" control={<Radio color="primary" />} label="Cash" />
                        </RadioGroup> */}
                    </DialogContent>

                    <DialogActions style={{ display: "flex", justifyContent: "space-evenly", marginTop: 5 }}>
                        {step === 1 && <Button className={classes.dialogButton} variant="outlined" color="default" onClick={() => setStep(0)}>Back</Button>}
                        <Button className={classes.dialogButton} variant="outlined" color="default" onClick={closeRechargeEditDialog}>Cancel</Button>
                        <Button disableElevation className={classes.dialogButton} variant="contained" color="secondary" onClick={step === 0 ? deviceWalletsUnderAmount : rechargeWalletDigital}>{step === 0 ? "Next" : "Recharge"} {loadWalletsAmount && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}</Button>
                    </DialogActions>
                </Dialog>
            </Portal>

            {loading && <Portal>
                <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "#0001", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <CircularProgress size={50} />
                </div>
            </Portal>}

            <Portal>
                <Dialog open={!!paymentFailedDialog} onClose={closePaymentFailedDialog} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle style={{ color: customTheme.palette.error.main }}><div style={{ fontSize: 16, textAlign: "center" }}>Payment Failed!</div></DialogTitle>
                    <DialogContent style={{ fontSize: 14, marginTop: 0, marginBottom: 10 }}>Description: {paymentFailedDialog}</DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "space-evenly" }}>
                        <Button className={classes.dialogButton} variant="outlined" color="default" onClick={closePaymentFailedDialog}>Cancel</Button>
                        <Button disableElevation className={classes.dialogButton} variant="contained" color="secondary" onClick={rechargeWalletDigital}>Retry</Button>
                    </DialogActions>
                </Dialog>
            </Portal>
        </div>
    );
}